export default __webpack_public_path__ + "static/media/web.c7d03e5e.png";